// extracted by mini-css-extract-plugin
export default {"Disabled":"_Disabled--rEZPH","MenuItem":"_MenuItem--wUgNL"};